import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Sentry debe inicializarse antes de suprimir console.error
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: 0.1,
    // No reportar errores de red esperados (401, 403, 404)
    beforeSend(event) {
      const msg = event?.exception?.values?.[0]?.value || '';
      if (/401|403|404|network/i.test(msg)) return null;
      return event;
    },
  });
}

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  // Mantener console.error activo — Sentry lo necesita para capturar errores no manejados
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
